import React, { useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import axiosClient from 'api/axiosClient';

// BE (rewritePluginfileHtml) đã đổi mọi ảnh pluginfile trong question HTML
// sang proxy URL relative `/elearning/book/pluginfile?fileurl=...&sig=`.
// FE chỉ cần prepend axios baseURL: nếu để relative, browser resolve theo
// FE host (lms domain ≠ api domain) → rơi vào CRA shell → ảnh vỡ. KHÔNG
// còn append `?token=<moodleToken>` (moodleToken đã bị strip Phase 2D →
// null → ảnh `?token=null` lỗi).
function resolveProxyImageUrls(html) {
  if (!html || typeof html !== 'string') return html;
  const apiBase = axiosClient.defaults.baseURL || '';
  if (!apiBase) return html;
  return html.replace(
    /(src|href)="\/elearning\/book\/pluginfile/g,
    `$1="${apiBase}/elearning/book/pluginfile`,
  );
}

// Ảnh/bảng trong HTML Moodle (đề bài/giải thích/đáp án) hay có kích thước
// cố định (vd <img width="800">) → tràn ngang trên điện thoại. Ép mọi media
// co theo bề rộng container, giữ tỉ lệ. Bảng cho cuộn ngang thay vì tràn.
const fitMedia = css`
  img,
  video,
  iframe {
    max-width: 100%;
    height: auto;
  }

  table {
    display: block;
    max-width: 100%;
    overflow-x: auto;
  }
`;

const QuestionTitle = styled(Card.Title)`
  ${fitMedia}
`;

const RichHtml = styled.div`
  ${fitMedia}
`;

const QuestionItem = ({
  question,
  slot,
  sequenceCheck,
  onAnswerChange,
  disabled = false,
}) => {
  const handleChange = (index) => {
    if (disabled) return;

    const payload = [
      {
        name: `q${question.id}:${slot}_answer`,
        value: index.toString(),
      },
      {
        name: `q${question.id}:${slot}_:sequencecheck`,
        value: sequenceCheck,
      },
      {
        name: `q${question.id}:${slot}_:flagged`,
        value: '0',
      },
    ];

    onAnswerChange(slot, payload);
  };
  
  const questionText = resolveProxyImageUrls(question.text);

  return (
    <Card className='mb-3'>
      <Card.Body>
        <QuestionTitle dangerouslySetInnerHTML={{ __html: questionText }} />
        <Form>
          {(question.answers || []).map((ans, index) => {
            const id = `q${question.id}:${slot}_answer_${index}`;
            return (
              <Form.Check
                key={index}
                type='radio'
                id={id}
                name={`q${question.id}:${slot}_answer`}
                label={ans.label}
                value={index}
                defaultChecked={ans?.checked}
                onChange={() => handleChange(index)}
                className='mb-2'
                disabled={disabled && !ans.checked}
              />
            );
          })}
        </Form>
        {question?.feedback && (
          <>
            <div className='mt-2'>
              <strong>Giải thích:</strong>
            </div>
            <RichHtml
              className='mt-2'
              dangerouslySetInnerHTML={{ __html: resolveProxyImageUrls(question.feedback) }}
            />
          </>
        )}
        {question?.rightAnswer && (
          <div className='mt-2'>
            <strong>Đáp án:</strong>
            <RichHtml className='mt-2' dangerouslySetInnerHTML={{ __html: resolveProxyImageUrls(question.rightAnswer) }} />
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default QuestionItem;
